import React from 'react';
import Plot from 'react-plotly.js';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
function reverseCumulativeSum(arr) {
    let result = [];
    let sum = 0;
    
    for (let i = arr.length - 1; i >= 0; i--) {
        sum += arr[i];
        result[i] = sum;
    }
    
    return result;
}

function cumulativeSum(arr) {
    let result = [];
    let sum = 0;
    
    for (let i = 0; i < arr.length; i++) {
        sum += arr[i];
        result[i] = sum;
    }
    
    return result;
}

export default function PlotsPanel(props)  {

    console.log(" transactions = ", props)
    const sorted_transactions = props.transactions.sort((a, b) => a.date - b.date)
    console.log("sorted_transactions = ", sorted_transactions)
    const data = [{
        x: sorted_transactions.map( t => t["date"].toISOString().slice(0,10)),
        y: cumulativeSum(sorted_transactions.map( t => parseInt(t.sum))),
        text: sorted_transactions.map( t => t.comment),
        type: 'scatter',
        mode: 'lines+markers',
        marker: {color: 'red'}}]
    const layout = {title: 'A Fancy Plot', xaxis: {title: 'Date', type: 'date'}, yaxis: {title: 'Sum'}}
    console.log("data = ", data)

    let comments = [...new Set(sorted_transactions.map( t => t.comment))]
    let sums = []
    let rows = []
    for(const i in comments) {
      let c = comments[i]
      let total = sorted_transactions.filter( t => t.comment == c).map(t => parseInt(t.sum)).reduce( (a,b) => a+b)
      sums = [...sums, total]
      rows = [...rows, {name:c, sum:total}]
    }
    rows = rows.sort((a, b) => a.sum - b.sum)

    const tableComponent = <TableContainer>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Sum</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row) => (
                    <TableRow key={row.name}>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.sum}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>

    console.log("comments = ", comments, "sums = ", sums)
    return (
        <div>
            <h1>Plot and Table</h1>
            <div style={{display:'flex'}}>
            <Plot  data={data}  layout={layout}/>
            {tableComponent}
            </div>
        </div>
    );
    
}